<section class="transits-page">
  <h1 class="transits-page__title">{{ title() }}</h1>
  <hd-transits-panel
    class="transits-page__panel"
    [compact]="viewport.isPhone()"
    (chartOpenRequested)="openChart($event)"
    (justNowRequested)="openJustNow()"
    (raveNewYearRequested)="openRaveNewYear($event)"
  ></hd-transits-panel>
</section>
